// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TrustSignalsGroup_wrapper__EreXC"};